import { render } from "./EscolaCrescimento.vue?vue&type=template&id=02eae6bf&scoped=true&lang=pug"
import script from "./EscolaCrescimento.vue?vue&type=script&setup=true&lang=js"
export * from "./EscolaCrescimento.vue?vue&type=script&setup=true&lang=js"

import "./EscolaCrescimento.vue?vue&type=style&index=0&id=02eae6bf&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02eae6bf"]])

export default __exports__